import { getToken, getUser,getRestoLogin } from "../Utils/Common";
import { getWithParamsAPICall } from "./axiosMethodCalls";

const API_URL = getRestoLogin() === "dreamnest" ? process.env.REACT_APP_BRIQUE_API : process.env.REACT_APP_ETTAS_API;

export const getVAT = async (menuInfo) => {
    let config = {
        headers: {
            "api-key": process.env.REACT_APP_API_KEY,
        }
    }
    try {
        const response = await getWithParamsAPICall(
            API_URL + "vats/computation", {
                requester: getUser(),
                token: getToken(),
                vat_in: menuInfo.price,
                is_vatable: menuInfo.is_vatable,
            }, config
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};
